import { render, staticRenderFns } from "./FindMoreSolutionsRequestModal.vue?vue&type=template&id=a0631024&scoped=true&"
import script from "./FindMoreSolutionsRequestModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./FindMoreSolutionsRequestModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0631024",
  null
  
)

export default component.exports